import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Mail, Copy, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

const EMAIL = "shillongteermorning4758@gmail.com";

export default function ReputedCounter() {
  const [copied, setCopied] = useState(false);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      setCopied(true);
      toast.success("Email copied to clipboard");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Copy failed — please long-press the email to copy");
    }
  };

  return (
    <div className="max-w-xl mx-auto w-full px-4 pt-8 pb-10">
      <Card className="p-6 sm:p-8 border-0 shadow-xl shadow-slate-900/10 bg-gradient-to-br from-emerald-500 to-teal-600 text-white rounded-2xl">
        <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-white/20 ring-1 ring-white/30 mb-4">
          <Mail className="h-7 w-7 text-white" strokeWidth={2.2} />
        </div>
        <h1 className="font-heading font-black text-3xl sm:text-4xl leading-tight">
          Contact Us
        </h1>
        <p className="text-white/90 text-sm sm:text-base mt-2 leading-relaxed">
          Kisi bhi jaankari, sujhaav ya shikayat ke liye humein email karein.
          We reply within a few hours.
        </p>

        <div className="mt-6 rounded-xl bg-white/15 ring-1 ring-white/25 px-4 py-4">
          <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-white/70 mb-1">
            Gmail
          </div>
          <div
            data-testid="counter-email-text"
            className="font-heading font-black text-lg sm:text-xl break-all text-white select-all"
          >
            {EMAIL}
          </div>
        </div>

        <div className="mt-5 grid grid-cols-2 gap-3">
          <Button
            asChild
            className="rounded-full bg-white text-emerald-700 hover:bg-white/90 font-bold"
            data-testid="counter-mailto"
          >
            <a href={`mailto:${EMAIL}`}>
              <Mail className="h-4 w-4 mr-2" /> Send Email
            </a>
          </Button>
          <Button
            onClick={copyEmail}
            variant="outline"
            className="rounded-full border-white/60 bg-transparent text-white hover:bg-white/10 hover:text-white font-bold"
            data-testid="counter-copy"
          >
            {copied ? (
              <>
                <Check className="h-4 w-4 mr-2" /> Copied
              </>
            ) : (
              <>
                <Copy className="h-4 w-4 mr-2" /> Copy
              </>
            )}
          </Button>
        </div>
      </Card>
    </div>
  );
}
